import { enumHorzPositioning, enumVertPositioning } from "../constants";

export function IsDefaultCP(boxLayout) {
  if (boxLayout.fDistRight != 0) return false;
  if (boxLayout.fDistBottom != 0) return false;
  if (boxLayout.fHorzPositioning != enumHorzPositioning.stayLeft) return false;
  if (boxLayout.fVertPositioning != enumVertPositioning.stayTop) return false;

  return true;
}
